import ArrowBottom from "assets/svg/arrow-bottom.svg";
import { FC, useState } from "react";

import styles from "./styles.module.css";

const Faq: FC = () => {
  const [current, setCurrent] = useState(0);
  const onCollapse = (id: number) => {
    id === current ? setCurrent(0) : setCurrent(id);
  };

  return (
    <div className="">
      <h1 className="mb-4 text-xs font-bold md:mb-5 md:text-base xl:mb-[30] xl:text-xl">
        سوالات متداول
      </h1>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(20)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          دادکوین چیست؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 20 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 20 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> مخاطبان گرامی که از طریق سایت دادبانان خرید می‌کنند، ده
            درصد کل مبلغ پرداختی آنها به عنوان اعتبار در کیف پولشان لحاظ می‌شود
            و می‌توانند از این اعتبار استفاده نمایند. این اعتبار صرفا متعلق به
            مخاطب بوده و قابل انتقال به غیر نمی‌باشد.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(1)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          دوره‌های آنلاین از طریق چه پلتفرمی برگزار می‌شوند و شرایط برگزاری به
          چه شکل هست؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 1 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 1 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> تمامی کلاس‌های آنلاین در پلتفرم اسکای‌روم از طریق پنل
            کاربری دانش‌پذیران در سایت دادبانان برگزار می‌شود، حین برگزاری کلاس
            امکان پرسش و پاسخ به دو صورت تایپی و از طریق دسترسی میکروفون وجود
            خواهد داشت. همچنین{" "}
            <u>برای ورود به کلاس نیاز به نصب هیچ نرم‌افزاری نمی‌باشد</u>، از
            طریق سایت دادبانان می‌توانید وارد کلاس شوید و در قسمت راهنمای سایت،{" "}
            <b>فیلم آموزشی</b> در خصوص نحوه ورود به کلاس و خرید دوره‌ها وجود
            دارد که در صورت تمایل می‌توانید مشاهده فرمائید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(2)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          در کلاس‌های آنلاین اگر امکان حضور در یک با تعدادی از جلسات میسر نشود
          آیا به مطالب گفته شده دسترسی خواهیم داشت؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 2 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 2 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> بله؛ اگر به هر دلیلی نتوانید در جلسه‌ای حضور پیدا کنید،
            مطالب عنوان شده را از دست نمی‌دهید و فیلم به صورت کامل ضبط می‌شود و
            در داشبورد پنل شخصی شما در سایت موسسه دادبانان قرار گرفته و قابلیت
            بازبینی به صورت مکرر را خواهد داشت.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(3)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          چگونه می‌توانیم از طریق دادبانان به شرکت‌های متقاضی مشاور حقوقی معرفی
          شویم؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 3 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 3 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> بعد از برگزاری هر کارگاه پرورش مشاور حقوقی، آزمونی توسط
            دادبانان به صورت آنلاین برگزار می‌شود؛ نفرات برتر این آزمون در صورت
            تمایل به شرکت‌های متقاضی مشاور حقوقی معرفی و توصیه می‌شوند.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(4)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          آیا آزمون مشاور حقوقی دادبانان به صورت حضوری برگزار می‌گردد؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 4 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 4 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> خیر، این آزمون به صورت آنلاین برگزار می‌‌‌گردد.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(5)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          وکیل یا کارآموز وکالت هستم، شرکت در کدام کارگاه‌‌‌ها برای من توصیه
          می‌‌‌شود؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 5 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 5 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> در کارگاه وکیل حرفه‌‌‌ای و یا کارگاه مشاور حقوقی
            می‌‌‌توانید شرکت کنید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(6)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          فیلم‌های کلاس‌ها تا چه مدت در پنل شخصی باقی می‌مانند؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 6 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 6 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> تا یک سال پس از اتمام کارگاه‌ها شما به فیلم و فایل‌های
            کلاس دسترسی خواهید داشت و در صورت درخواست، این زمان با موافقت
            دادبانان قابل تمدید خواهد بود.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(7)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          به تازگی در رشته‌‌‌ی حقوق فارغ التحصیل شده‌‌‌ام، مناسب‌‌‌ترین کارگاه
          برای من کدام است؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 7 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 7 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> اگر فارغ التحصیل حقوق هستید و وکیل یا کارآموز نیستید در
            کارگاه پرورش مشاور حقوقی می‌توانید شرکت کنید چون استخدام شدن به
            عنوان مشاور یا کارشناس حقوقی در شرکت‌‌‌ها نیاز به پروانه وکالت
            ندارد.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(8)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          در اطلاعات دوره روی سایت گفته شده 100% "آنلاین" و 0% "آفلاین" آیا
          مشاهده فیلم جلسات برگزار شده ممکن نیست؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 8 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 8 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> منظور از "آفلاین" دوره‌هایی است که به صورت آفلاین در
            استودیو ضبط شده‌اند، قرارگیری دوره‌های آنلاین در داشبورد شما و
            مشاهده آن به صورت مستمر با گزینه‌‌‌ی دوره‌های آفلاین متفاوت است. شما
            مجدد می‌توانید فیلم جلسات را بازبینی کنید، بنابراین آنلاین بودن
            کلاس، مانع مشاهده فیلم کلاس آنلاین پس از اتمام کلاس نیست.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(9)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          آیا دریافت مدارک پایان دوره مشروط به شرکت و یا قبولی در آزمون خاصی
          است؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 9 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 9 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> خیر؛ تمامی دوره‌های دادبانان کاملاً مهارت‌محور و
            کاربردی هستند و شما با فراگیری و همراهی مستمر در کلاس و یادگیری
            مطالب تدریس شده در هر جلسه می‌توانید پس از اتمام دوره آموزشی مدرک
            خود را دریافت نمایید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(10)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          مدرک پایان دوره را به چه روشی می‌توانم دریافت کنم؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 10 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 10 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> ارسال مدارک به صورت پستی می‌‌‌باشد، می‌‌‌بایست پس از
            اعلام صدور مدارک کارگاه از طریق هماهنگی با شماره واتساپ آموزش، نسبت
            به دریافت مدارک خود اقدام بفرمائید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(11)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          با شرکت در کارگاه‌‌‌ها مدرک پایان دوره صادر خواهد شد؟ و مدرک دوره چه
          کاربردی دارد؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 11 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 11 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> بله، پس از اتمام جلسات کارگاه مدرک پایان‌‌‌دوره برای
            شما صادر خواهد شد و می‌‌‌توانید در صورت تمایل به عنوان رزومه نیز
            استفاده نمائید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(12)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          برای ورود به کلاس از طریق اسکای روم باید چه نرم‌افزاری نصب شود؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 12 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 12 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> برای ورود به کلاس نیاز به نصب نرم‌افزار خاصی ندارید.
            کافیست وارد سایت دادبانان شوید دکمه ورود را انتخاب کنید، پس از وارد
            کردن شماره موبایل خود و وارد کردن کد پیامک شده، در قسمت داشبورد
            گزینه کارگاه مورد نظر را انتخاب کنید. همچنین در روز و ساعت مقرر
            کارگاه طبق برنامه دکمه ورود به کلاس را انتخاب کنید و وارد پلتفرم
            برگزاری کارگاه شوید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(13)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          درصورت بروز مشکل حین ورود به کلاس چه کار کنیم؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 13 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 13 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> درصورت بروز خطا و مواجه شدن با هر گونه مشکل حین فرآیند
            ورود به کارگاه، ابتدا اطمینان حاصل نمائید که مرورگر شما آخرین نسخه و
            به‌روزرسانی شده باشد، در صورت عدم رفع مشکل به دو نکته دیگر نیز توجه
            داشته باشید: <b>اولاً</b> فی-لتر-شک-ن شما خاموش باشد، <b>ثانیاً</b>{" "}
            سیستم شما می‌‌‌بایست به اینترنت مناسب وصل باشد و سایر صفحات در گوگل
            به راحتی باز شوند.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(14)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          در سیستم IOS چگونه می‌توان در کلاس‌های آنلاین شرکت کرد؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 14 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 14 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> شما می‌توانید از نسخه به روز شده مرورگر Safari استفاده
            نمایید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(15)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          برای ورود به کلاس آنلاین از چه مرورگرهایی می‌توان استفاده نمود؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 15 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 15 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> مرورگر Google Chrome بهترین گزینه جهت ورود به کلاس‌های
            آنلاین هست. اگر سیستم عامل دستگاه IOS بود برای ورود به کلاس از
            مرورگر Safari هم می‌توانید استفاده نمایید.
            <b>
              {" "}
              نکته حائز اهمیت این هست که مرورگر Google Chrome یا Safari شما
              آخرین نسخه و به‌روزرسانی شده باشد.{" "}
            </b>
            توجه: در صورتی که هنگام ورود به کلاس با صفحه سفید مواجه شدید،{" "}
            <b>
              کش مرورگر خود را پاک کنید به این صورت که با کلیک نمودن همزمان سه
              دکمه‌‌‌ی "Ctrl+Shift+Delete" در کیبورد سیستم شخصیتان، پنجره‌‌‌ای
              برای شما باز می‌‌‌شود که نیاز هست در قسمت "Time range" گزینه "All
              time"
            </b>{" "}
            را انتخاب کنید و سپس در مرحله پایانی نیز بر روی گزینه‌‌‌ی{" "}
            <b>"Clear data"</b> کلیک بفرمائید. پس از طی کردن مراحل فوق به صورت
            کامل، لطفا مجدد برای ورود به کلاس اقدام کنید.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(16)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          آیا فیلم‌های آفلاین قرارگرفته شده در داشبورد شخصی قابلیت دانلود دارند؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 16 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 16 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> خیر، فیلم جلسات به صورت اختصاصی منحصراً در پنل کاربری
            دانش‌پذیران بر روی نمایشگر سایت مؤسسه دادبانان با چند کیفیت مختلف در
            دسترس و قابل پخش با سرعت‌های مختلف است.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(17)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          اگر صفحه سایت در حالت لود شدن باقی ماند راه حل چیست؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 17 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 17 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> لطفاً در صورت امکان نوع اتصال اینترنت خود را تغییر دهید
            و پس از حصول اطمینان از مناسب بودن سرعت اینترنت خود، فی-لتر-شک-ن
            سیستم یا تلفن همراه خود را خاموش کرده و مجدد اقدام به ورود فرمایید
            (دقت فرمائید که معمولا با یک مرتبه ورود و خروج مجدد مشکل شما حل
            می‌‌‌شود).
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(18)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          کدملی و اطلاعات تکمیلیم را در سایت اشتباه وارد کردم برای ویرایش آن‌ها
          چه کاری باید انجام بدم؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 18 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 18 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> تمامی اطلاعات پنل کاربری شما به استثنای شماره تلفن
            همراه، از طریق ورود به پنل کاربریتان قابل ویرایش خواهد بود.
          </p>
        )}
      </div>
      <div
        className={`relative mb-[15px] cursor-pointer overflow-hidden rounded-[5px] bg-white py-[30px] pr-[38px] pl-[30px] ${styles.box}`}
        onClick={() => onCollapse(19)}
      >
        <h2 className="pl-[2rem] text-[13px] md:text-[15px] xl:text-[16px]">
          آیا پاورپوینت کلاس‌ها هم در داشبوردمان قرار داده ‌می‌شود؟
        </h2>
        <ArrowBottom
          className={`absolute top-[1.9rem] left-[1.9rem] -ml-1 h-6 w-6 fill-current transition-all ${
            current === 19 ? "rotate-180" : "rotate-0"
          }`}
        />
        {current === 19 && (
          <p className="mt-[40px] text-justify text-[12px] md:text-[15px] xl:text-[16px]">
            <b>پاسخ:</b> چنان‌چه استاد دوره، فایل پاورپوینت یا PDF یا هر فایل
            دیگری را برای ارائه درس استفاده کند، این فایل پس از موافقت استاد در
            داشبورد دانش‌پذیران قرار خواهد گرفت.
          </p>
        )}
      </div>
    </div>
  );
};

export default Faq;
